import { Flex, Text } from '@chakra-ui/react';
import { Radio } from '@morressier/alembic';
import { FieldLabel } from 'src/components/Field';
import { GeneralInfoRadioOption } from './GeneralInfo/generalInfoConfig';

/**
 * The peer review models as a radio list, for the flows that ask for one before
 * the article type exists and so cannot go through the row's edit modal. The
 * options come from `PEER_REVIEW_MODEL_OPTIONS`, the same list that modal shows.
 */
const PeerReviewModelSelect = ({
  value,
  options,
  onChange,
  isRequired = true
}: {
  value: string;
  options: GeneralInfoRadioOption[];
  onChange: (value: string) => void;
  isRequired?: boolean;
}) => (
  <Flex flexDirection="column" gap={2}>
    <FieldLabel
      label="Peer Review Model"
      subText="Decides which review fields authors are asked for on this article type."
      isRequired={isRequired}
    />
    {options.map(option => (
      <Radio
        key={option.value}
        name="peerReviewModel"
        value={option.value}
        checked={value === option.value}
        onChange={() => onChange(option.value)}
        ariaLabel={option.value}
        id={`peer-review-model-${option.value}`}
      >
        <Text textStyle="headingItem">{option.label}</Text>
        <Text>{option.subText}</Text>
      </Radio>
    ))}
  </Flex>
);

export default PeerReviewModelSelect;
